import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { AssetType } from 'src/components/GlintsPicture/interfaces';

import { PARTNER_LOGOS, PartnerLogo } from '../constants';
import * as Styled from './TrustStrip.sc';

const PauseGlyph = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="3" y="2.5" width="2.6" height="9" rx="1" fill="currentColor" />
    <rect x="8.4" y="2.5" width="2.6" height="9" rx="1" fill="currentColor" />
  </svg>
);

const PlayGlyph = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M4 2.5 11 7 4 11.5 Z" fill="currentColor" />
  </svg>
);

const TRUST_HEADING_ID = 'landing-trust-heading';

const renderLogo = (logo: PartnerLogo, hidden: boolean) => (
  <Styled.LogoItem
    key={hidden ? `dup-${logo.id}` : logo.id}
    $scale={logo.scale ?? 1}
    $tintBlack={Boolean(logo.tintBlack)}
  >
    <Styled.LogoImage
      name={logo.name}
      assetType={AssetType.dstLandingSgPage}
      alt={hidden ? '' : logo.alt}
      sizes="220px"
      breakpoints={220}
      lazy={true}
    />
  </Styled.LogoItem>
);

export const TrustStrip: React.FC = () => {
  const intl = useIntl();
  const [isPaused, setIsPaused] = React.useState(false);

  return (
    <Styled.Section>
      <Styled.Inner>
        <Styled.Eyebrow id={TRUST_HEADING_ID}>
          <FormattedMessage
            id="landing-sg.trust.heading"
            defaultMessage="Trusted by"
          />
        </Styled.Eyebrow>
      </Styled.Inner>

      <Styled.PauseButton
        type="button"
        onClick={() => setIsPaused((paused) => !paused)}
        aria-label={intl.formatMessage(
          isPaused
            ? {
                id: 'landing-sg.trust.resume',
                defaultMessage: 'Resume partner logo carousel',
              }
            : {
                id: 'landing-sg.trust.pause',
                defaultMessage: 'Pause partner logo carousel',
              }
        )}
      >
        {isPaused ? PlayGlyph : PauseGlyph}
      </Styled.PauseButton>

      <Styled.MarqueeViewport
        role="region"
        aria-labelledby={TRUST_HEADING_ID}
        tabIndex={0}
      >
        <Styled.MarqueeTrack $paused={isPaused}>
          <Styled.MarqueeGroup>
            {PARTNER_LOGOS.map((logo) => renderLogo(logo, false))}
          </Styled.MarqueeGroup>
          <Styled.MarqueeGroup aria-hidden="true">
            {PARTNER_LOGOS.map((logo) => renderLogo(logo, true))}
          </Styled.MarqueeGroup>
        </Styled.MarqueeTrack>
      </Styled.MarqueeViewport>
    </Styled.Section>
  );
};

export default TrustStrip;
